/**
 * Hides the Klaviyo 15% teaser while Shopify's cookie banner is visible.
 *
 * Shopify and Klaviyo both inject their UI after the page starts loading, so
 * this observes DOM changes instead of repeatedly checking with a timer. When
 * the cookie banner closes, the state class is removed and the teaser returns.
 */
(() => {
  const bannerSelector = '#shopify-pc__banner';
  const visibleStateClass = 'shopify-cookie-banner-visible';
  let bannerObserver = null;
  let observedBanner = null;
  let updateQueued = false;

  const isVisible = (element) => {
    if (!element || element.hidden) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const watchBannerAttributes = (banner) => {
    if (banner === observedBanner) return;

    bannerObserver?.disconnect();
    observedBanner = banner;

    if (!banner) return;

    bannerObserver = new MutationObserver(queueUpdate);
    bannerObserver.observe(banner, {
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style'],
    });
  };

  const updateState = () => {
    updateQueued = false;
    const banner = document.querySelector(bannerSelector);

    watchBannerAttributes(banner);
    document.documentElement.classList.toggle(visibleStateClass, isVisible(banner));
  };

  function queueUpdate() {
    if (updateQueued) return;

    updateQueued = true;
    window.queueMicrotask(updateState);
  }

  const pageObserver = new MutationObserver(queueUpdate);

  const start = () => {
    pageObserver.observe(document.body, { childList: true, subtree: true });
    updateState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
